var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-spin",class:{
    'z-spin-fix': _vm.fix,
    'z-spin-show-text': _vm.custom,
    'z-spin-fullscreen': _vm.fullscreen,
    'z-spin-small': _vm.size === 'small',
    'z-spin-large': _vm.size === 'large',
  },style:({ backgroundColor: _vm.backgroundColor })},[_c('div',{staticClass:"z-spin-main"},[_c('div',{staticClass:"z-spin-dot"}),_vm._v(" "),_c('div',{staticClass:"z-spin-text"},[_vm._t("default")],2)])])}
var staticRenderFns = []
export { render, staticRenderFns }